import { scrollHint } from './modules/scrollHint';
import { toggleSitemap } from './modules/sitemap';
import { spSlider } from './modules/swiper';

scrollHint();
toggleSitemap();
spSlider();
